import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { addAlert, apiOfflineAsync } from 'src/app/layouts/pages/pages.component';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { getLanguageCookie } from 'src/assets/language';
import { v4 } from 'uuid';

@Component({
  selector: 'app-strategic-planning',
  templateUrl: './strategic-planning.component.html',
  styleUrls: ['./strategic-planning.component.scss']
})
export class StrategicPlanningComponent implements OnInit {
  @Input() parameters: any = {}

  dataSource!: MatTableDataSource<any>;
  displayedColumns: string[] = ['organization', 'name', 'action', 'result', 'date', 'delete'];
  currentPage = 1;
  currentPageReq = 1;
  itemsPerPage = 10;

  searchOrganizationResponsible: string = ''
  organizationResponsibleArray: any = []
  createResponsibleOrganogram: boolean = false;
  
  newOrganizationResponsible = {name: ''};

  constructor(private corporationService: CorporationService){
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.dataSource.data = this.parameters?.item?.strategicPlanning || []
    this.organizationResponsibleArray = this.parameters?.optionsArray?.organizationResponsibleArray
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  isData(){
    return this.dataSource.data.length > 0
  }

  getDisplayedRows(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.dataSource.data.slice(startIndex, endIndex);
  }

  getColumns(){
    return this.displayedColumns.slice(1)
  }

  getItemsPerPage(){
    return this.itemsPerPage
  }

  getCurrentPages(): number{
    return this.currentPage
  }

  choseItemsPage(number: number){
    this.itemsPerPage = number;
    this.getDisplayedRows()
  }

  onPageChange(newPage: number, text: string): void {
    this.currentPage = newPage;
  }

  getTotalPages(): number {
    return Math.ceil(this.dataSource.data.length / this.itemsPerPage);
  }

  async checkValue() {
    let total = this.getTotalPages()
    if (this.currentPage > total) this.currentPage = total;
  }

  newStrategicPlanning(){
    if(!this.parameters.isEdit){
      return
    }
    const json = {
      uuid: v4(),
      organization: '',
      name: '',
      action: '',
      result: '',
      date: '',
    };
    this.dataSource.data.push(json)
  }

  async deleteStrategicPlanning(uuid: string) {
    if(!this.parameters.isEdit){
      return
    }

    this.dataSource.data = this.dataSource.data.filter(item => item.uuid !== uuid);
    this.parameters.item.strategicPlanning = this.dataSource.data
  }

  choseItemSelect(type: string, value: any, element: any){
    switch (type) {
      case 'responsibleOrganization':
        if(value.uuid == '-1'){
          this.createResponsibleOrganogram = true
        }else{
          element.organization = value.name
        }
        break;
      default:
        break;
    }
  }

  async setCorporationResponsibleOrganization(){
    let flag = false;

    this.organizationResponsibleArray.forEach((item: any) => {
      if(item.name == this.newOrganizationResponsible.name){
        addAlert('orange', this.getLanguages('businessSolution/modal/rules/errors/typeProcedure'))
        flag = true
        return
      }
    });

    if(flag){
      return
    }
    
    if(this.newOrganizationResponsible.name == 'New +'){
      addAlert('danger', this.getLanguages('auth/alert/nameReservedWord'))
      return
    }

    try {
      const response:any = await this.corporationService.setCorporationResponsibleOrganization(this.newOrganizationResponsible);
      if (response && [201, 202].includes(response.status) ) {
        addAlert('success', response.message)
        await this.getCorporationResponsibleOrganization();
      } else {
        addAlert('danger', response.message)
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.createResponsibleOrganogram = false;
    this.newOrganizationResponsible.name = ''
  }
  
  async getCorporationResponsibleOrganization(event?: any) {
    try {
      const response: any = await this.corporationService.getCorporationResponsibleOrganization();
      if (response && response.data) {
        let tempArray = response.data
        tempArray = tempArray.filter((item: any) => item.name && item.uuid)
          .map((item: any) => ({
            name: item.name,
            uuid: item.uuid
          }))
        this.organizationResponsibleArray = [...tempArray];
        if (this.getSystemPermission('business_solutions', 'create_responsible_organization')) {
          this.organizationResponsibleArray.unshift({ name: 'New +', uuid: '-1' })
        }
      } else {
        throw new Error('Erro ao consultar tipos de anexos!\nConsulta o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  getSystemPermission(screen: string, action: string) {
    return systemPermissionsNew(screen, action)
  }

  formatContent(event: Event, row: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    let value = textarea.value;

    // Remove todos os caracteres exceto números e barras
    value = value.replace(/[^\d/]/g, '');
    // Se o valor estiver vazio, retorna vazio
    if (!value) {
      row.date = '';
      return;
    }
    value = this.formatDateInput(value);
    // Limita o tamanho total da string para DD/MM/AAAA (10 caracteres)
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    row.date = value;
    this.autoResize(event, row);
  }

  autoResize(event: Event, row?: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    const tr = textarea.closest('tr');
    
    if (!tr) {
      return;
    }

    const textareas = tr.querySelectorAll('textarea');
    let maxHeight = 0;

    textareas.forEach((ta: HTMLTextAreaElement) => {
      ta.style.height = 'auto'; 
      const taHeight = ta.scrollHeight;
      if (taHeight > maxHeight) {
        maxHeight = taHeight;
      }
    });

    textareas.forEach((ta: HTMLTextAreaElement) => {
      ta.style.height = `${maxHeight}px`;
    });
  }

  validateInput(event: KeyboardEvent, row: any): boolean {
    const charCode = event.charCode;
    const char = String.fromCharCode(charCode);

    // Permite apenas números e barra
    if (!/[\d/]/.test(char)) {
      event.preventDefault();
      return false;
    }
    
    // Se for barra, verifica se já não existe uma barra no campo
    if (char === '/') {
      const textarea = event.target as HTMLTextAreaElement;
      if (textarea.value.includes('/')) {
        event.preventDefault();
        return false;
      }
    }

    return true;
  }

  getPlaceholder(type: string): string {
    return 'DD/MM/AAAA';
  }

  formatDateInput(value: string): string {
    // Remove todos os caracteres não numéricos
    let numbers = value.replace(/\D/g, '');
    
    // Limita a 8 dígitos (ddmmaaaa)
    numbers = numbers.substring(0, 8);
    
    // Apenas dia
    if (numbers.length >= 1 && numbers.length <= 2) {
      if (numbers === '00') return '01';
      return numbers;
    } else if (numbers.length >= 3 && numbers.length <= 4) {
      // Dia e mês
      let day = numbers.substring(0, 2);
      let month = numbers.substring(2);

      if (day === '00') day = '01';
      if (month === '00') month = '01';

      const monthInt = parseInt(month);
      let maxDay = 31;
      if ([4, 6, 9, 11].includes(monthInt)) {
        maxDay = 30;
      } else if (monthInt === 2) {
        maxDay = 29; // Só limita para 29, pois não há ano ainda
      }
      if (parseInt(day) > maxDay) day = String(maxDay).padStart(2, '0');
      if (parseInt(month) > 12) month = '12';

      return `${day}/${month}`;
    } else if (numbers.length >= 5) {
      // Dia, mês e ano
      let day = numbers.substring(0, 2);
      let month = numbers.substring(2, 4);
      let year = numbers.substring(4, 8); // <-- garantir que year está definido

      if (day === '00') day = '01';
      if (month === '00') month = '01';

      const monthInt = parseInt(month);
      let maxDay = 31;
      if ([4, 6, 9, 11].includes(monthInt)) {
        maxDay = 30;
      } else if (monthInt === 2) {
        // Verifica se é ano bissexto apenas se o ano tiver 4 dígitos
        if (year.length === 4) {
          const yearInt = parseInt(year);
          if ((yearInt % 4 === 0 && yearInt % 100 !== 0) || (yearInt % 400 === 0)) {
            maxDay = 29;
          } else {
            maxDay = 28;
          }
        } else {
          maxDay = 29; // Permite até 29 enquanto o ano não está completo
        }
      }
      if (parseInt(day) > maxDay) day = String(maxDay).padStart(2, '0');
      if (parseInt(month) > 12) month = '12';
      if (year <= '2000') year = '2000';

      return `${day}/${month}/${year}`;
    }
    
    return numbers;
  }

}
